<template lang="pug">
.event-preview-component
  .preview-wrapper
    .flex-preview(v-bind:style="_previewStyle")
      .sub-title
        span {{ _facilityName }}
      .title
        span.text-break {{ title }}
      .date
        span.name 日付
        span(v-show="date") {{ _getDate }}（{{ _getWeek }}）
      .time
        span.name 時間
        span(v-show="timeFrom") {{ _getTimeFrom }}～{{ _getTimeTo }}
      .place
        span.name 場所
        span.text-break {{ place }}
      .hold-type
        span.name 開催
        span {{ _getHoldTypeName }}
      .reply-deadline
        span.name 申込
        span {{ _getReplyDeadline  }}
      hr
      .contents.pre-line.text-break {{ description }}
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import { userStore } from "@/store/store";
import eventDefaultImage from "@/assets/event-default.png";
import { EventHoldType } from "@/commons/services/Events";

/**
 * イベントプレビュー
 */
@Component
export default class EventPreview extends Vue {
  /** 日付 */
  @Prop({ type: Number })
  date!: number;

  /** 開始時刻 */
  @Prop({ type: String })
  timeFrom!: string;

  /** 終了時刻 */
  @Prop({ type: String })
  timeTo!: string;

  /** 場所 */
  @Prop({ type: String })
  place!: string;

  /** タイトル */
  @Prop({ type: String })
  title!: string;

  /** 開催 */
  @Prop({ type: Number || null })
  holdType!: number;

  /** 参加申込み */
  @Prop({ type: Boolean || null })
  needReply!: boolean;

  /** 参加申込期日 */
  @Prop({ type: Number })
  replyDeadline!: number;

  /** 内容 */
  @Prop({ type: String })
  description!: string;

  /** 画像URL */
  @Prop()
  imageUrl!: string;

  /**
   * vue lifecycle created
   */
  public created(): void {
    return;
  }

  get _facilityName(): string {
    if (!userStore.facility) {
      return "施設名未登録";
    }

    return userStore.facility.name ? userStore.facility.name : "施設名未登録";
  }

  get _previewStyle(): any {
    let style = {};

    if (this.imageUrl) {
      style = { background: `url(${this.imageUrl}) 0% 0%/453px 300px no-repeat` };
    } else {
      style = { background: `url(${eventDefaultImage}) 0% 0%/453px 300px no-repeat` };
    }

    return style;
  }

  get _getDate(): string {
    let date: string = "";
    if (this.date) {
      date = this.$dateUtil.convertNumberToString(this.date, "yyyy年mm月dd日", false);
    }

    return date;
  }

  get _getTimeFrom(): string {
    let timeFrom: string = "";
    if (this.timeFrom) {
      timeFrom = this.timeFrom.slice(0, 5);
    }

    return timeFrom;
  }

  get _getTimeTo(): string {
    let timeTo: string = "";
    if (this.timeTo) {
      timeTo = this.timeTo.slice(0, 5);
    }

    return timeTo;
  }

  /** 曜日文字列 */
  get _getWeek(): string {
    let weekName: string = "";
    if (this.date) {
      // 日付はyyyy年mm月dd日の書式になっているので、数値に変換した後にDate型に変換する
      let date: string = this.$dateUtil.convertNumberToString(this.date, "yyyy/mm/dd hh:MM:ss");
      const eventDate: Date = new Date(date);
      weekName = this.$dateUtil.getWeekName(eventDate, "ja");
    }

    return weekName;
  }

  get _getHoldTypeName(): string {
    if (this.holdType == null) {
      return "";
    }

    switch (this.holdType) {
      case EventHoldType.LOCAL_ONLY: {
        return "現地開催";
      }
      case EventHoldType.ONLINE_ONLY: {
        return "オンライン開催";
      }
      case EventHoldType.LOCAL_AND_ONLINE: {
        return "現地とオンライン開催";
      }
      default: {
        return "";
      }
    }
  }

  get _getReplyDeadline(): string {
    if (this.needReply == true && this.replyDeadline != null) {
      const replyDeadlineDate: string = this.$dateUtil.convertNumberToString(this.replyDeadline, "参加申込みはmm月dd日まで", false);
      return replyDeadlineDate;
    } else {
      return "参加申込み受付無し";
    }
  }
}
</script>

<style lang="scss" scoped>
.event-preview-component {
  // .flex-previewにborderを指定すると背景画像がズレるので、枠線用の段落でラップする
  .preview-wrapper {
    border: solid 2px rgba(0, 0, 0, 0.5);
    border-radius: 20px;
    width: 457px;
    display: block;

    .flex-preview {
      padding: 310px 10px 10px 10px;
      width: 453px;
      border-radius: 20px;
      background-color: rgba(255, 255, 255, 1);

      .sub-title {
        margin: 8px 0 0 8px;

        span {
          font-size: 14px !important;
        }
      }

      .title {
        margin: 8px 0 0 8px;
        font-weight: bold;
        font-size: 20px;
      }
      .date,
      .time,
      .place,
      .hold-type,
      .reply-deadline {
        margin: 6px 0 0 8px;
        font-size: 16px;
        & > .name {
          display: inline-block;
          width: 50px;
          font-weight: bold;
        }
        word-wrap: break-word;
      }
      .contents {
        padding: 0 8px 8px 8px;
        font-size: 16px;
        word-wrap: break-word;
      }
      hr {
        margin: 8px 0 8px 0;
      }
    }
  }
}
</style>
